<template>
    <div class="row">
        <div class="col">
        <h2 class="titre">Consultation Service d'urgence</h2>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col-4 lbl text-vertical-center">
                    <label>Classe :</label>
                </div>
                <div class="col txt">
                    <p v-if="!urgence.classeSocieteAfficher"> ... </p>
                    <p v-else> {{ urgence.classeSocieteAfficher }} </p>
                </div>
            </div>
            <div class="row">
                <div class="col-4 lbl text-vertical-center">
                    <label>Société :</label>
                </div>
                <div class="col txt">
                    <p v-if="!urgence.nomSociete"> ... </p>
                    <p v-else> {{ urgence.nomSociete }} </p>
                </div>
            </div>
        </div>
        <div class="col">
        </div>
    </div>
    <!--Corps policiers -->
    <div v-if="classeSociete == classesUrgence[0]">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Unité/ section/ division/ escouade :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.unite"> ... </p>
                        <p v-else> {{ urgence.unite }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Nom contact :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.contact"> ... </p>
                        <p v-else> {{ urgence.contact }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>District/ secteur/ arrondissement/ poste :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.district"> ... </p>
                        <p v-else> {{ urgence.district }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Prénom contact :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.prenom"> ... </p>
                        <p v-else> {{ urgence.prenom }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>No. D'évènement/ no.Dossier/ nom du projet :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.evenement"> ... </p>
                        <p v-else> {{ urgence.evenement }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Fonction/ grade :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.fonction"> ... </p>
                        <p v-else> {{ urgence.fonction }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Matricule :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.matricule"> ... </p>
                        <p v-else> {{ urgence.matricule }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Courriel :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.courriel"> ... </p>
                        <p v-else> {{ urgence.courriel }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Téléphone :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.telephone"> ... </p>
                        <p v-else> {{ this.$commun.formatPhone(urgence.telephone) }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Poste téléphonique :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.poste"> ... </p>
                        <p v-else> {{ urgence.poste }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                <div class="col-4 lbl text-vertical-center">
                    <label>Télécopieur :</label>
                </div>
                <div class="col txt">
                    <p v-if="!urgence.telecopieur"> ... </p>
                    <p v-else> {{ this.$commun.formatPhone(urgence.telecopieur)}} </p>
                </div>
            </div>
            </div>
            <div class="col"/>
        </div>
    </div>
    <!--Ambulanciers -->
    <div v-if="classeSociete == classesUrgence[1]">
        <div class="row">
        <div class="col">
            <div class="row">
                <div class="col-4 lbl text-vertical-center">
                    <label>Ville :</label>
                </div>
                <div class="col txt">
                    <p v-if="!urgence.ville"> ... </p>
                    <p v-else> {{ urgence.ville }} </p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="row">
                <div class="col-4 lbl text-vertical-center">
                    <label>Contact :</label>
                </div>
                <div class="col txt">
                    <p v-if="!urgence.contact"> ... </p>
                    <p v-else> {{ urgence.contact }} </p>
                </div>
            </div>
        </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Motif :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.motifAfficher"> ... </p>
                        <p v-else> {{ urgence.motifAfficher }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Statut :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.statutAfficher"> ... </p>
                        <p v-else> {{ urgence.statutAfficher }} </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--Service d'incendie -->
    <div v-if="classeSociete == classesUrgence[2]">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>District/ secteur/ arrondissement/ poste :</label>
          </div>
          <div class="col txt">
              <p v-if="!urgence.district"> ... </p>
              <p v-else> {{ urgence.district }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>Contact :</label>
          </div>
          <div class="col txt">
              <p v-if="!urgence.contact"> ... </p>
              <p v-else> {{ urgence.contact }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>Téléphone :</label>
          </div>
          <div class="col txt">
              <p v-if="!urgence.telephone"> ... </p>
              <p v-else> {{ this.$commun.formatPhone(urgence.telephone) }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>Télécopieur :</label>
          </div>
          <div class="col txt">
              <p v-if="!urgence.telecopieur"> ... </p>
              <p v-else> {{ this.$commun.formatPhone(urgence.telecopieur) }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>Courriel :</label>
          </div>
          <div class="col txt">
              <p v-if="!urgence.courriel"> ... </p>
              <p v-else> {{ urgence.courriel }} </p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-4 lbl text-vertical-center">
            <label>Premier répondant :</label>
          </div>
          <div class="col">
            <Checkbox v-model="urgence.repondant" :binary="true" disabled/>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!--Centre d'aide (probl.jeu) -->
    <div v-if="classeSociete == classesUrgence[3]">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Numéro de téléphone :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.telephone"> ... </p>
                        <p v-else> {{ this.$commun.formatPhone(urgence.telephone) }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Nom contact :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.contact"> ... </p>
                        <p v-else> {{ urgence.contact }} </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Poste téléphonique :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.poste"> ... </p>
                        <p v-else> {{ urgence.poste }} </p>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-4 lbl text-vertical-center">
                        <label>Prénom contact :</label>
                    </div>
                    <div class="col txt">
                        <p v-if="!urgence.prenom"> ... </p>
                        <p v-else> {{ urgence.prenom }} </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ButtonBar @fermer="fermer"/>
</template>

<script>
import ButtonBar from '../../../components/dossier/Consulter/ButtonBarUrgence.vue'
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    name: 'ConsulterUrgence',
    components: {
        ButtonBar
    },
    mounted() {
        this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Consulter un Urgence");
        this.getUrgence();
    },
    data() {
        return {
            isDataLoading: false,
            urgence: {},
            classeSociete: null,
        };
    },
    computed: {
        ...mapGetters({
        jeton: 'cardex/jeton',
      profil: 'cardex/profil',
        classesUrgence: 'urgence/classesUrgence'
        })
    },
    methods: {
        getUrgence(){
            this.$store.dispatch('urgence/consulterUrgenceAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site
            }).then((res) => {
                this.assignerUrgence(res);
                this.isDataLoading = false;
            })
        },
        assignerUrgence(res){
            this.urgence = res.data.entite;
            this.classeSociete = res.data.entite.classeSociete;
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },            
    },
}
</script>
